import { CSSProperties } from "react";
import { useNotifications } from "./NotificationContext";
import { XNotification } from "./XNotification";

export type XNotificationsProps = {
  style?: CSSProperties;
  margin?: number;
  gap?: number;
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right";
  notificationStyle?: CSSProperties;
};

export const XNotifications = ({
  style,
  margin = 12,
  gap = 8,
  position = "bottom-right",
  notificationStyle,
}: XNotificationsProps) => {
  const { notifications } = useNotifications();

  const verticalAttributes: CSSProperties = position.startsWith("top")
    ? { top: 0, paddingTop: margin, justifyContent: "flex-start" }
    : { bottom: 0, paddingBottom: margin, justifyContent: "flex-end" };

  const horizontalAttributes: CSSProperties = position.endsWith("left")
    ? { left: 0, paddingLeft: margin }
    : { right: 0, paddingRight: margin };

  return (
    <div
      style={{
        ...verticalAttributes,
        ...horizontalAttributes,
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        gap,
        overflowX: "hidden",
        overflowY: "visible",
        pointerEvents: "none",
        ...style,
      }}
    >
      {notifications.map((notification) => (
        <XNotification
          key={notification.id}
          notification={notification}
          style={notificationStyle}
        />
      ))}
    </div>
  );
};
